<template>
  <div class="input-box" :class="getClasses">
    <template v-if="type === 'date'">
      <div class="datepicker-input-button" @click="handleClickDatePickerIcon">
        <custom-icon icon="calendar-icon" color="dark-gray" height="1.8rem" width="1.8rem" />
      </div>
      <custom-datepicker :format="$u.locale.validator('moment.date')"
                         ref="datePicker"
                         :range="range"
                         @input="refactorValueType"
                         v-model="value" />
    </template>
    <input type="text"
           :id="inputId.toString()"
           :class="[getClasses, currency ? 'has-currency' : '', {'not-valid': typeof initialValue === 'object' && !initialValue.isValid}]"
           :autocomplete="'new-password'"
           :name="Math.random()"
           :placeholder="getPlaceHolder"
           @focus="inputFocused"
           @blur="refactorValueType(true)"
           @contextmenu="handleContextMenuClicked($event)"
           @input="value = $u.trim($event.target.value), refactorValueType()"
           @keyup.enter="value = $u.trim($event.target.value), refactorValueType(), $emit('enter:keyUp', typeof initialValue === 'object' ? initialValue.value : value)"
           :value="value"
           :disabled="(typeof initialValue === 'object' && initialValue.disabled) || disabled"
           style="background: transparent !important;">

    <span v-if="currency" class="currency" @click="handleFocusInput">{{ currency.hasOwnProperty('label') ? currency.label : currency.hasOwnProperty('value') ? currency.value : currency }}</span>

    <vs-icon
      v-if="returnValue && value !== firstValue"
      class="undo-button"
      icon="replay"
      style="font-size: 1.7rem;"
      @click="handleReturnValueClick"/>
  </div>
</template>

<script>
import DatePicker from 'vue-persian-datetime-picker'
import CustomDatepicker from '@/components/datepicker/customDatepicker.vue'
import CustomIcon from "../../icon/customIcon.vue";

export default {
  name: 'InputBox',
  model: {
    prop: 'initialValue',
    event: 'inputValueChange'
  },
  props: {
    initialValue: {
      type: [String, Object, Number],
      default: ''
    },
    align: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    returnValue: {
      type: Boolean,
      default: true
    },
    range: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {CustomIcon, CustomDatepicker, DatePicker},
  data () {
    return {
      value: '',
      firstValue: '',
      inputId: ''
    }
  },
  computed: {
    getClasses () {
      const classes = []
      switch (this.type) {
      case 'price':
      case 'number':
        classes.push('price-style')
        if (!this.align) {
          classes.push('text-right')
        }
        break
      }

      if (this.align) {
        classes.push(`text-${this.align}`)
      }

      if (this.returnValue) {
        classes.push('return-value')
      }
      return classes
    },
    getPlaceHolder () {
      if (typeof this.initialValue === 'object') {
        if (this.type === 'price') {
          return this.$u.priceFormat((this.initialValue.placeHolder || '').toString(), true)
        }
        return (this.initialValue.placeHolder || '').toString() || ''
      } else return ''
    }
  },
  created () {
    if (this.initialValue) {
      if (typeof this.initialValue === 'object') {
        this.value = this.initialValue.value
        this.firstValue = this.initialValue.value
      } else {
        this.value = this.initialValue
        this.firstValue = this.initialValue
      }
      this.refactorValueType(true)
    }
    this.inputId = Math.random()
  },
  methods: {
    handleClickDatePickerIcon () {
      const datePickerEl = this.$refs.datePicker
      if (datePickerEl && !this.disabled) {
        datePickerEl.$refs.datePicker.focus()
      }
    },
    refactorValueType (blur = false) {
      if (this.type) {
        switch (this.type) {
        case 'price':
          this.value = this.$u.priceFormat(this.value, blur)
          break

        case 'number':
          this.value = this.value.toString().replace(/\D/g, '') || ''
          break
        }
      } else {
        switch (typeof this.initialValue) {
        case 'number':
          this.value = this.$u.parseFloat(this.value.replace(/\/r/g, '/')) || 0
          break
        }
      }
      if (typeof this.initialValue === 'object') {
        this.$emit('inputValueChange', {...this.initialValue, value: this.value, placeHolder: this.initialValue.placeHolder || '', isValid: this.initialValue.hasOwnProperty('isValid') ? this.initialValue.isValid : true})
      } else {
        this.$emit('inputValueChange', this.value)
      }
    },
    inputFocused (event) {
      if (this.type === 'date') {
        this.$refs.datePicker.$refs.datePicker.visible = true
      }
      this.$emit('focus')
      event.target.setSelectionRange(0, event.target.value.length)
    },
    handleFocusInput () {
      window.document.getElementById(this.inputId.toString()).focus()
    },
    updateFirstValue () {
      this.firstValue = this.value
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.value
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleReturnValueClick () {
      this.value = this.firstValue.toString()
      this.refactorValueType()
    }
  },
  watch: {
    initialValue: {
      handler () {
        if (typeof this.initialValue === 'object') {
          if (this.value !== this.initialValue.value) {
            this.value = this.initialValue.value
            this.refactorValueType(true)
          }
        } else if (this.value !== this.initialValue) {
          this.value = this.initialValue
          this.refactorValueType(true)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import "../../../assets/scss/vuexy/variables";

  .input-box {
    width: 100%;
    height: 100%;

    .datepicker-input-button {
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0.5rem;
    }

    .vpd-input-group {
      width: 2rem !important;
      position: absolute;
      top: calc(100% / 2 - 1.5rem);
      left: 0.2rem;

      .vpd-icon-btn {
        display: none;
      }

      .form-control {
        border: 0;
        width: 100%;
        display: none;
        line-height: 3.5rem;
      }
    }

    input {
      height: 100%;
      direction: ltr;
      text-align: left;
      border: none;
      width: 100%;
      padding: 0 1rem;
      font-size: inherit;
      //transition: border 0.6s cubic-bezier(.48, .24, .36, .99);

      &.return-value {
        padding-right: 3rem;
      }

      &.has-currency {
        padding-right: 7rem;
      }

      &.not-valid {
        color: $danger;
      }

      /*&:focus {
        border-bottom: 1px solid #000;
      }*/
    }

    .currency {
      position: absolute;
      right: 3.8rem;
      z-index: 100;
      color: #888888;
      font-size: 1.3rem;
      font-weight: 400;
    }

    .undo-button {
      position: absolute;
      right: 1rem;
      top: 0;
      bottom: 0;
      margin: auto;
      height: fit-content;
      cursor: pointer;
      color: #3891bc;
    }
  }

</style>
